import type {
  Driver,
  IDriverSpreadsheetRowAPI,
  NewDriver,
} from '@cobliteam/api-lib';

export const trimDriverName = (
  driver: Driver | NewDriver
): Driver | NewDriver => {
  return {
    ...driver,
    name: driver.name.trim(),
  };
};

export const trimDriverNameFromSpreadsheet = (
  driver: IDriverSpreadsheetRowAPI
): IDriverSpreadsheetRowAPI => {
  return {
    ...driver,
    name: driver.name.trim(),
  };
};
